export default "__VITE_PUBLIC_ASSET__638f3159__"